import {getTenantHostName} from "./TenantService.js";
import {getQueryParamValue} from "./getQueryParamValue.js";
import {PEC, getAliasConfig} from "./PECAlias.js";
import {
  setConsigneeStates,
  setOrderId,
  setPage,
  populateShipments,
  setRiderNumber,
  setRiderName,
} from "./setData.js";

import {sortAndCheckDeliveries} from "./sortData.js";
import {getMapMarkerObject} from "./utils.js";
import {notFoundTemplate, onlyMap} from "./templates.js";
import {cancelledStates} from "./consignmentStates.js";
import getMapData from "./getMapData.js";

var settings = ({tenantDNS, orderId, tenantId, shipmentId}) => ({
  url: orderId
    ? `https://${tenantDNS}/app/order/v1/api/external/ordertrackingV2/orderId/${orderId}`
    : `https://${tenantDNS}/app/order/v1/api/external/ordertrackingV2/shipmentId/${shipmentId}`,
  method: "GET",
  timeout: 0,
  headers: {
    "x-coreos-request-id": "unAuth1",
    "x-coreos-tid": tenantId,
  },
});

var consigneeData = ({tenantDNS, orderId, tenantId, shipmentId}) => ({
  url: orderId
    ? `https://${tenantDNS}/app/order/v1/api/external/ordertrackingV2/rider/order/${orderId}`
    : `https://${tenantDNS}/app/order/v1/api/external/ordertrackingV2/rider/shipment/${shipmentId}`,
  method: "GET",
  timeout: 0,
  headers: {
    "x-coreos-request-id": "unAuth1",
    "x-coreos-tid": tenantId,
  },
});

var configUI = ({tenantDNS, tenantId}) => ({
  url: `https://${tenantDNS}/app/ui-config/api/app/configs`,
  method: "GET",
  timeout: 0,
  headers: {
    "x-coreos-request-id": "unAuth1",
    "x-coreos-tid": tenantId,
  },
});

const isCancelled = (events) => {
  for (let i = 0; i < events.length; i++) {
    const ERCODE =
      events[i]?.eventCode +
      (events[i]?.reasonCode ? `-${events[i]?.reasonCode}` : "");

    if (cancelledStates.includes(ERCODE)) return true;
  }

  return false;
};

export const imageBaseUrl = "https://dispatch1-assets.getos1.com/assets/";

const getData = async () => {
  if (window.location.pathname === "/tracking/map-view/") {
    // added map in HTML
    setPage(onlyMap());

    // Hiding footer and header
    document
      .querySelectorAll(".footerCol")
      .forEach((el) => (el.style.display = "none"));
    document.querySelector("header").style.display = "none";

    const time = getQueryParamValue("time");
    getMapData();

    setInterval(
      () => {
        getMapData();
      },
      time ? time * 1000 : 5000,
    );
  } else {
    let showRiderDetails = false;
    let riderStatus = "";
    let isReverseOrder = false;
    const orderId =
      getQueryParamValue("orderID") || getQueryParamValue("orderId");
    const shipmentId = getQueryParamValue("shipmentId");

    // console.log(orderId,shipmentId);
    const tenantConfig = await getTenantHostName();

    $.ajax(
      settings({
        tenantDNS: tenantConfig?.tenantDns,
        orderId,
        tenantId: tenantConfig?.tenantId,
        shipmentId,
      }),
    )
      .done(function (response) {
        //data is loaded correctly
        $(".loader").css("display", "none");

        // if(!sessionStorage.getItem("labels_config")){
        $.ajax(
          configUI({
            tenantDNS: tenantConfig?.tenantDns,
            tenantId: tenantConfig?.tenantId,
          }),
        )
          .done(function (response) {
            async function getAlias() {
              await getAliasConfig(response?.data);
              sessionStorage.setItem("labels_config", JSON.stringify(PEC));
              const event = new Event("localStorageChanged");
              window.dispatchEvent(event);
            }
            getAlias();
          })
          .fail((error) => {
            console.log(error);
          });
        // }

        isReverseOrder = false;

        if (response?.data?.order?.shipmentFlow) {
          isReverseOrder =
            response?.data?.order?.shipmentFlow?.toLowerCase() == "reverse";
        }

        if (isReverseOrder) $("#step-delivered").remove();
        else if (!isReverseOrder) $("#step-return").remove();

        const orgName = response?.data?.orgName;
        // not found or cancelled

        const isOrderCancelled = isCancelled(
          response?.data?.shipmentTracking[0]?.events,
        );

        if (!response?.data?.order?.clientOrderId || isOrderCancelled) {
          const template = notFoundTemplate(orgName, "not-found.svg");
          setPage(template);
          return;
        }

        const sortedEvents = sortAndCheckDeliveries(
          response?.data?.shipmentTracking[0]?.events,
          isReverseOrder,
          response?.data?.order?.state,
        );

        setOrderId({
          orderID: response?.data?.order?.clientOrderId,
          orderState: response?.data?.order?.state,
          isReverseOrder: isReverseOrder,
          attemptCount: response?.data?.order?.attemptCount,
          isRecentPickupFailed: sortedEvents?.isRecentPickupFailed,
          isRecentDropFailed: sortedEvents?.isRecentDropFailed,
        });

        populateShipments(
          response?.data?.job?.containers,
          response?.data?.order?.clientOrderId,
        );

        const riderLoc = getMapMarkerObject(
          response?.data?.riderTracking[
            response?.data?.riderTracking?.length - 1
          ],
          "Rider",
          imageBaseUrl + "rider_vehicle.svg",
          "lon",
        );
        const dropLoc = getMapMarkerObject(
          response?.data?.job?.drop?.geolocation,
          "Drop",
          imageBaseUrl + "map-home.svg",
          "long",
        );
        showRiderDetails = response?.data?.showRiderDetails;

        if (
          (showRiderDetails && !isReverseOrder && sortedEvents.ispickedUp) ||
          (showRiderDetails &&
            isReverseOrder &&
            !sortedEvents.ispickedUp &&
            sortedEvents.isRiderAssigned)
        ) {
          const riderName = response?.data?.riderName;
          setRiderName(riderName, isReverseOrder);
          $.ajax(
            consigneeData({
              tenantDNS: tenantConfig?.tenantDns,
              orderId,
              tenantId: tenantConfig?.tenantId,
              shipmentId,
            }),
          )
            .done(function (response) {
              //data is loaded correctly
              $(".loader").css("display", "none");
              if (
                (showRiderDetails &&
                  !isReverseOrder &&
                  sortedEvents.ispickedUp) ||
                (showRiderDetails &&
                  isReverseOrder &&
                  !sortedEvents.ispickedUp &&
                  sortedEvents.isRiderAssigned)
              ) {
                if (response?.data?.primaryMobile != null) {
                  const countryCode =
                    response?.data?.primaryMobile?.countryCode ?? "";
                  const phoneNumber =
                    response?.data?.primaryMobile?.number ?? "";
                  setRiderNumber({countryCode, phoneNumber});
                }
              }
            })
            .fail((error) => {
              console.error(error);
            });
        }

        // const makers = [
        // 	// pickupLoc,
        // 	...(!isNaN(riderLoc?.position?.lat) ? [riderLoc] : []),
        // 	dropLoc,
        // ];

        const markers = {
          riderLoc,
          dropLoc,
        };

        setConsigneeStates(
          sortedEvents,
          orderId ?? response?.data?.order?.clientOrderId,
          markers,
          isReverseOrder,
          response?.data?.order?.attemptCount,
          response?.data?.order?.state,
        );
      })
      .fail((error) => {
        console.error(error);
      });
  }
};

getData();
